import React, { Component } from 'react'
import onClickOutside from 'react-onclickoutside'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import NotificationsIcon from '@material-ui/icons/Notifications'

import Avatar from '@components/Avatar'
import HeaderDropdown from '@components/HeaderDropdown'
import { notificationApi } from '@atheneum/api'

class HeaderActions extends Component {
  static propTypes = {
    userStore: PropTypes.object,
    notificationStore: PropTypes.object
  }

  state = {
    toggleNotificationDropdown: false,
    toggleMenuDropdown: false
  }

  handleClickOutside = () => {
    this.setState({
      toggleNotificationDropdown: false,
      toggleMenuDropdown: false
    })
  }

  renderNotificationCount () {
    const { notificationStore } = this.props
    if (notificationStore.count === 0) return null
    return (
      <div className='count'>
        <span>{notificationStore.count}</span>
      </div>
    )
  }

  handleNotificationIconClick = () => {
    notificationApi.updateToSeen()
    this.setState({
      toggleNotificationDropdown: !this.state.toggleNotificationDropdown,
      toggleMenuDropdown: false
    })
  }

  handleMenuClick = () => {
    this.setState({
      toggleMenuDropdown: !this.state.toggleMenuDropdown,
      toggleNotificationDropdown: false
    })
  }

  handleLogout = () => {
    const { userStore } = this.props
    userStore.logout()
  }

  render () {
    const { userStore } = this.props
    return (
      <div className='header__actions'>
        <div className='header__actions__navigation'>
          <div className='single' onClick={this.handleNotificationIconClick}>
            <NotificationsIcon fontSize='large' className='mobile-menu-icon' />
            {this.renderNotificationCount()}
          </div>
          <div
            className='header__actions__navigation__user'
            onClick={this.handleMenuClick}
          >
            <div className='header__profile-image'>
              <Avatar
                alt='User avatar'
                src={userStore.user.picture && userStore.user.picture.path}
              />
            </div>
            <p>{get(userStore.user, 'fullName', '')}</p>
          </div>
        </div>
        {this.state.toggleNotificationDropdown && (
          <HeaderDropdown
            isNotification
            handleOutsideClick={this.handleClickOutside}
          />
        )}
        {this.state.toggleMenuDropdown && (
          <HeaderDropdown handleOutsideClick={this.handleClickOutside} />
        )}
      </div>
    )
  }
}

export default inject('notificationStore', 'userStore')(
  onClickOutside(observer(HeaderActions))
)
